/* Validation messages for company registration / VAT numbers (same text as Go crMessage / vatMessage). */
import { countryOf } from "../../domain/country";

export function crMessage(country: string): string {
  return countryOf(country).code === "SA" ? "must be 10 digits" : "invalid registration number";
}

export function vatMessage(country: string): string {
  const c = countryOf(country);
  if (c.code === "SA") return "must be 15 digits";
  if (!c.vat.pattern) return `must be empty (no VAT in ${c.name[0]})`;
  return "must be " + c.vat.hint[0];
}
